import { render, staticRenderFns } from "./ReportStockAdjustment.vue?vue&type=template&id=5ab5b00a&"
import script from "./ReportStockAdjustment.vue?vue&type=script&lang=ts&"
export * from "./ReportStockAdjustment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab5b00a')) {
      api.createRecord('5ab5b00a', component.options)
    } else {
      api.reload('5ab5b00a', component.options)
    }
    module.hot.accept("./ReportStockAdjustment.vue?vue&type=template&id=5ab5b00a&", function () {
      api.rerender('5ab5b00a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/reports/ReportStockAdjustment.vue"
export default component.exports